module.exports = __webpack_public_path__ + "img/republic-of-macedonia.3d467388.svg";